// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggler-language[data-v-aabb9552]{display:flex;flex-direction:column;grid-gap:var(--spaces-m);align-items:center}@media(min-width:800px){.toggler-language[data-v-aabb9552]{flex-direction:row}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
